import { Typography } from "@mui/material";
import {
  CalendarClockIcon,
  UserHeartIcon,
  UserIcon,
} from "@/components/common/icons";
import useMedspaTimezone from "@/hooks/common/useMedspaTimezone";
import { getUniqServicesProviders } from "@/utils/appointment";
import AppointmentDateTimeSummary from "../../appointmentDateTimeSummary";
import { useMultiProviderAppointmentDrawerContext } from "../multiProviderAppointmentDrawerContext";
import { SuccessScreenSectionStack } from "./successScreenSectionStack";

export const SuccessScreenBasicInformation = () => {
  const { medspaTimezone, medspaZonedTimeToUtc } = useMedspaTimezone();
  const { client, appointmentServices } =
    useMultiProviderAppointmentDrawerContext();

  const appointmentStartTime = appointmentServices[0]?.startTime;
  const appointmentEndTime = appointmentServices.at(-1)?.endTime;

  const servicesProviders = getUniqServicesProviders(appointmentServices);
  const isSingleProvider = servicesProviders.length === 1;

  return (
    <SuccessScreenSectionStack
      label="Basic information"
      options={[
        {
          icon: <UserIcon size={24} />,
          content: (
            <Typography variant="labelSmall">
              {client?.firstName} {client?.lastName ?? ""}
            </Typography>
          ),
        },
        {
          icon: <CalendarClockIcon size={24} />,
          content: (
            <AppointmentDateTimeSummary
              startTime={medspaZonedTimeToUtc(appointmentStartTime)}
              endTime={medspaZonedTimeToUtc(appointmentEndTime)}
              medspaTimezone={medspaTimezone}
              primaryVariant="labelSmall"
              secondaryColor="text.secondary"
            />
          ),
        },
        ...(isSingleProvider
          ? [
              {
                icon: <UserHeartIcon size={24} />,
                content: (
                  <Typography variant="labelSmall">
                    {servicesProviders[0]?.user?.firstName}{" "}
                    {servicesProviders[0]?.user?.lastName}
                  </Typography>
                ),
              },
            ]
          : []),
      ]}
    />
  );
};
